<template>
	<div v-show="!showModal && !showEditModal">
		<a-spin :spinning="loading">
			<a-form ref="form" :model="formState" name="form" @finish="onSearch">
				<a-row>
<!--					<a-form-item class="ui-form__item" name="organizationId" label="影院组织">-->
<!--						<a-select placeholder="请选择" v-model:value="formState.organizationId" style="width: 250px;" @change="(id) => getAllCinemaList(id, true)">-->
<!--							&lt;!&ndash; <a-select-option :value="0">全部</a-select-option> &ndash;&gt;-->
<!--							<a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>-->
<!--						</a-select>-->
<!--					</a-form-item>-->

<!--					<a-form-item class="ui-form__item" name="cinemaId" label="所属影院">-->
<!--						<a-select placeholder="请选择" v-model:value="formState.cinemaId" style="width: 250px;">-->
<!--							<a-select-option :value="0">全部</a-select-option>-->
<!--							<a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>-->
<!--						</a-select>-->
<!--					</a-form-item>-->
          <a-form-item label="是否一券通" name="isOneVoucher" class="ui-form__item">
            <a-select v-model:value="formState.isOneVoucher" style="width: 180px;" placeholder="请选择状态">
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item class="ui-form__item" name="useCinemaId" label="可用影院">
            <a-select placeholder="请选择" v-model:value="formState.useCinemaId" style="width: 250px;">
              <a-select-option :value="''">全部</a-select-option>
              <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

				</a-row>

				<a-row v-show="showAll">

					<a-form-item label="批次号" name="batchNo" class="ui-form__item">
						<a-input v-model:value="formState.batchNo" placeholder="请输入批次号"></a-input>
					</a-form-item>

					<a-form-item label="批次号名称" name="name" class="ui-form__item">
						<a-input v-model:value="formState.name" placeholder="请输入批次号名称"></a-input>
					</a-form-item>

					<a-form-item label="使用政策名称" name="batchName" class="ui-form__item">
						<a-input v-model:value="formState.rulesName" placeholder="请输入使用政策名称"></a-input>
					</a-form-item>

					<a-form-item label="是否通兑" name="isHoliday" class="ui-form__item">
						<a-select v-model:value="formState.isHoliday" placeholder="请选择是否通兑" style="width: 190px;">
							<a-select-option :value="''">全部</a-select-option>
							<a-select-option :value="1">通兑</a-select-option>
							<a-select-option :value="0">非通兑</a-select-option>
						</a-select>
					</a-form-item>

					<a-form-item label="是否用于商品卖品发放" name="isGrant" class="ui-form__item">
						<a-select v-model:value="formState.isGrant" placeholder="请选择是否用于商品卖品发放" style="width: 190px;">
							<a-select-option :value="''">全部</a-select-option>
							<a-select-option :value="1">是</a-select-option>
							<a-select-option :value="0">否</a-select-option>
						</a-select>
					</a-form-item>

					<a-form-item label="有效期开始时间" class="ui-form__item">
						<a-range-picker v-model:value="time"></a-range-picker>
					</a-form-item>

					<a-form-item label="有效期结束时间" class="ui-form__item">
						<a-range-picker v-model:value="time1"></a-range-picker>
					</a-form-item>
				</a-row>

				<a-row>
					<a-col :span="18">
						<span v-if="pageType" v-permission="['coupon_preferential_recordInfo_set']" style="margin-right: 20px;">
							<userSelect :pageType="1" @change="getData"></userSelect>
						</span>
						<a-button style="margin-right: 20px;" v-permission="[pageType ? 'coupon_preferential_recordInfo_add' : 'coupon_preferential_record_add']" type="primary" @click="onAdd">新增兑换券</a-button>
						<a-button style="margin-right: 20px;" type="primary" @click="onImportModal" v-permission="[pageType ? 'coupon_preferential_recordInfo_export' : 'coupon_preferential_record_export']">导入</a-button>
            <span v-permission="[pageType ? 'coupon_preferential_recordInfo_export' : 'coupon_preferential_record_export']">
							<ExportReport  type="couponBatch" :searchData="searchData"></ExportReport>
						</span>
						<a style="margin-left: 20px;" @click="showAll = !showAll">
							{{ showAll ? '收起' :'展开' }}
							<Icon v-show="!showAll" icon="DownOutlined"></Icon>
							<Icon v-show="showAll" icon="UpOutlined"></Icon>
						</a>
					</a-col>
					<a-col :span="6" style="text-align: right;">
						<a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
						<a-button @click="reset">重置</a-button>
					</a-col>
				</a-row>
			</a-form>

			<div style="margin-top: 20px;">
				<a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="list" :scroll="{ x: 2500 }">
					<template #headerCell="{ column }">
					    <template v-if="column.key === 'importCount'">
					        兑换券数量
							<a-tooltip>
								<template #title>
									兑换券数量不包含已删除和已禁用的券
								</template>
								<Icon icon="QuestionCircleOutlined"></Icon>
							</a-tooltip>
					    </template>
						<template v-if="column.key === 'bindCount'">
						    已绑定数量
							<a-tooltip>
								<template #title>
									已绑定数量不包含已删除和已禁用的券
								</template>
								<Icon icon="QuestionCircleOutlined"></Icon>
							</a-tooltip>
						</template>
						<template v-if="column.key === 'redeemedCount'">
						    未兑换数量
							<a-tooltip>
								<template #title>
									未兑换数量不包含已删除和已禁用的券
								</template>
								<Icon icon="QuestionCircleOutlined"></Icon>
							</a-tooltip>
						</template>
					</template>
					<template #bodyCell="{ column, record }">
						<template v-if="column.key === 'createdTime'">
							{{ transDateTime(record.createTime) }}
						</template>

						<template v-if="column.key === 'time'">
							<div v-if="record.validPeriodType === 7">
								领取后{{ record.period }}天内有效
							</div>
							<div v-else>
								{{ transDateTime(record.receiveStartTime, 1) }} - {{ transDateTime(record.receiveEndTime, 1) }}
							</div>
						</template>

						<template v-if="column.key === 'isHoliday'">
							<div v-if="record.isHoliday">通兑</div>
							<div v-else>非通兑</div>
						</template>

						<template v-if="column.key === 'redeemedCount'">
							{{ record.importCount - record.redeemedCount }}
						</template>

						<template v-if="column.key === 'type'">
							{{ record.isImport ? '导入' : '新增' }}
						</template>

						<template v-if="column.key === 'isGrant'">
							{{ record.isGrant ? '是' : '否' }}
						</template>
            <template v-if="column.key === 'isOneVoucher'">
              {{ record.isOneVoucher ? '是' : '否' }}
            </template>
            <template v-if="column.key === 'cinemaNames'">
              {{ record.isOneVoucher == 1 ? '全部影院' : record.cinemaNames }}
            </template>


						<template v-if="column.key === 'action'">
							<a-dropdown :trigger="['click', 'hover']">
								<a-button @click.prevent>操作 <Icon icon="DownOutlined"></Icon>
								</a-button>
								<template #overlay>
									<a-menu>
										<div @click="onSee(record)">
											<a-menu-item>查看</a-menu-item>
										</div>
										<div v-permission="[pageType ? 'coupon_preferential_recordInfo_edit' : 'coupon_preferential_record_edit']" @click="onEdit(record)">
											<a-menu-item>修改</a-menu-item>
										</div>
										<div v-permission="[pageType ? 'coupon_preferential_recordInfo_detail' : 'coupon_preferential_record_detail']" @click="onDetail(record)">
											<a-menu-item>
												查看批次号详情
											</a-menu-item>
										</div>
										<div v-permission="[pageType ? 'coupon_preferential_recordInfo_use' : 'coupon_preferential_record_use']">
											<a-menu-item>
												<rulesList :id="record.id" :rulesId="record.couponPolicyId" @onRef="getData">
													<span>更换使用政策</span>
												</rulesList>
											</a-menu-item>
										</div>
										<div v-permission="[pageType ? 'coupon_preferential_recordInfo_importRecord' : 'coupon_preferential_record_importRecord']" @click="onImportRecord(record)">
											<a-menu-item>导入兑换券</a-menu-item>
										</div>
										<div v-permission="[pageType ? 'coupon_preferential_recordInfo_import' : 'coupon_preferential_record_import']">
											<a-menu-item>
												<!-- 导出 -->
												<exportComponent type="couponsList" :searchData="{ voucherImportId: record.id, couponType: 1 }">
													<div>导出</div>
												</exportComponent>
											</a-menu-item>
										</div>
										<div v-permission="[pageType ? 'coupon_preferential_recordInfo_delete' : 'coupon_preferential_record_delete']" @click="onDelete(record)">
											<a-menu-item>
												删除
											</a-menu-item>
										</div>
									</a-menu>
								</template>
							</a-dropdown>
						</template>
					</template>
				</a-table>
			</div>

			<a-modal v-model:visible="importVisible" title="导入兑换券" width="850px" @ok="onImportCard" @cancel="resetImportModelRef">
				<a-spin :spinning="loading">
					<a-form ref="importFormRef" name="importFormRef" scrollToFirstError :model="importModelRef"
							:labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }">

						<a-form-item v-if="!importId" name="organizationId" label="影院组织" :rules="[{ required: true, message: '必选项不允许为空' }]">
							<a-select placeholder="请选择" v-model:value="importModelRef.organizationId" @change="(id) => getAllCinemaList(id, false)">
								<a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>
							</a-select>
						</a-form-item>
            <a-form-item v-if="!importId" label="是否一券通" name="isOneVoucher" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }">
              <a-radio-group v-model:value="importModelRef.isOneVoucher">
                <a-radio :value="1" :disabled="!isOneCardOpen">是</a-radio>
                <a-radio :value="0">否</a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item v-if="!importId && !importModelRef.isOneVoucher" label="可用影院" name="cinemaIds" :rules="[{required: true, message: '必填项不允许为空'}]">
              <a-select v-model:value="importModelRef.cinemaIds" mode="tags" placeholder="请选择影院">
                <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
<!--						<a-form-item v-if="!importId" name="cinemaId" label="所属影院" :rules="[{ required: true, message: '必选项不允许为空' }]">-->
<!--							<a-select placeholder="请选择" v-model:value="importModelRef.cinemaId">-->
<!--								<a-select-option v-for="item in cinemaList" :vlaue="item.id" :key="item.id"> {{ item.name }}</a-select-option>-->
<!--							</a-select>-->
<!--						</a-form-item>-->

						<a-form-item v-if="!importId" label="兑换券批次号" name="batchNo" :rules="[{ required: true, message: '必填项不允许为空' }]">
							<a-row>
								<a-col :span="24">
									<a-input v-model:value="importModelRef.batchNo" placeholder="请输入" />
								</a-col>
								<!-- <a-col :span="8">
									<a-button :disabled="!importModelRef.batchNo" type="primary">查询兑换券批次号是否存在</a-button>
								</a-col> -->
							</a-row>
						</a-form-item>

						<a-form-item v-if="!importId" label="兑换券批次名称" name="name" :rules="[{ required: true, message: '必填项不允许为空' }]">
							<a-input v-model:value="importModelRef.name" placeholder="请输入" />
						</a-form-item>

						<a-form-item v-if="!importId" label="有效期" name='time' :rules="[{required: true, message: '必填项不允许为空'}]">
							<a-range-picker v-model:value="importModelRef.time"/>
						</a-form-item>

						<a-form-item v-if="!importId" label="是否通兑" name="isHoliday" :rules="[{ required: true, message: '必填项不允许为空' }]">
							<a-radio-group v-model:value="importModelRef.isHoliday" style="margin-top: 4px;">
								<a-radio :value="1">通兑</a-radio>
								<a-radio :value="0">非通兑</a-radio>
							</a-radio-group>

							<div style="margin-top: 10px;font-size: 13px;color: red;">
								<div>通兑：指在任何日期都可以兑换，不受限制</div>
								<div>非通兑：指不适用于影院编排的公共假期。如需在不适用的时间内兑换则需要进行补差</div>
							</div>
						</a-form-item>

						<a-form-item v-if="!importId && importModelRef.isHoliday === 0" label="补差金额" name="diffPrice" :rules="[{ required: true, message: '必填项不允许为空' }]">
							<a-input-number v-model:value="importModelRef.diffPrice" :min="0" :precision="2" placeholder="请输入" /> 元
						</a-form-item>

						<a-form-item v-if="!importId" label="是否启用" name="isDisabled" :rules="[{ required: true, message: '必填项不允许为空' }]">
							<a-radio-group v-model:value="importModelRef.isDisabled">
								<a-radio :value="0">启用</a-radio>
								<a-radio :value="1">禁用</a-radio>
							</a-radio-group>
						</a-form-item>

						<a-form-item v-if="!importId" label="是否用于商品卖品发放" name="isGrant" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }">
							<a-radio-group v-model:value="importModelRef.isGrant">
								<a-radio :value="1">是</a-radio>
								<a-radio :value="0">否</a-radio>
							</a-radio-group>
						</a-form-item>

						<a-form-item label="点击下载">
							<!-- @click="onDownload" -->
							<a href="/dashboard/导入兑换券模板.xlsx">Excel模板</a>
						</a-form-item>

						<a-form-item label="选择文件">
							<a-upload v-model:file-list="fileList" list-type="picture" action="/admin/ajaxUpload.do"
									  accept=".xlsx" :max-count="1" :beforeUpload="beforeUpload" @customRequest="() => {}">
								<a-button>
									<Icon icon="UploadOutlined"></Icon>
									上传
								</a-button>
							</a-upload>
						</a-form-item>

						<p style="font-size: 13px;color:red;text-align: center;">
							注：请下载模板输入信息，填写完成后保存，然后选择表格上传 {{ !importId ? '，批量导入仅可导入一个批次' : '' }}
						</p>

						<a-form-item v-if="!importId" label="使用规则" name="useRule" :rules="[{required: true, message: '必填项不允许为空'}]">
							<a-textarea v-model:value="importModelRef.useRule" placeholder="请输入使用规则,换行需要输入'|'字符"></a-textarea>
						</a-form-item>
					</a-form>
				</a-spin>
			</a-modal>
		</a-spin>
	</div>
	<detail v-if="showModal" :id="id" :organizationId='organizationId' @back="onBack"></detail>
	<temp v-if="showEditModal" :id="id" :isSee="isSee" :isEdit="isEdit" @back="onBack"></temp>
</template>

<script>
	import {
		Icon
	} from '@/components/icon/icon.js';
	import detail from './detail.vue';
	import temp from '@/views/coupon/preferential/list/temp.vue';
	import exportComponent from '@/components/exportReport/exportReport.vue';
	import rulesList from '@/components/rules/index.vue';
	import userSelect from '@/components/selectUser/index.vue';
	import { getOrganizationList, getCinemaList } from '@/service/modules/cinema.js';
	import { getImportRecord, importExcel, deleteImportRecord, delAndSync, importRecordExcel } from '@/service/modules/coupon.js';
  import { getCinemaSetting } from '@/service/modules/system.js';
  import ExportReport from '@/components/exportReport/exportReport.vue';
	export default {
		components: {Icon, detail, temp, exportComponent, rulesList, userSelect, ExportReport },
		data() {
			return {
				loading: false,
				showAll: false,
				organizationList: [],
				cinemaAllList: [],
				formState: {
					// organizationId: 0,
          couponType: 1,
					cinemaId: 0,
					isHoliday: '',
					isGrant: '',
          isOneVoucher:'',
          useCinemaId: '',
				},
				time: [],
				time1: [],
				cinemaList:[],
				searchData: {},
				showModal: false,
				modelRef: {
					time: []
				},
				importId: 0,
				importVisible: false,
				importModelRef: {
					isHoliday: 1,
					isDisabled: 0,
					isGrant: 0,
          isOneVoucher: 0,
          cinemaIds: []
				},
				fileList: [],
				showAddModal: false,
				list: [],
				columns: [
        //   {
				// 	title: '所属影院',
				// 	dataIndex: 'cinemaName'
				// },
          {
					title: '批次号',
					dataIndex: 'batchNo'
				}, {
					title: '批次号名称',
					dataIndex: 'name'
				}, {
					title: '使用政策名称',
					dataIndex: 'couponPolicyName'
				}, {
					title: '类型',
					key: 'type',
					width: 100
				}, {
          title: '是否一券通',
          key: 'isOneVoucher',
          width: 100
        }, {
          title: '可用影院',
          key: 'cinemaNames',
          dataIndex: 'cinemaNames',
          width: 200,
        },{
					title: '有效期',
					key: 'time',
					width: 200
				}, {
					title: '是否通兑',
					key: 'isHoliday',
					width: 130
				}, {
					title: '补差金额（元）',
					dataIndex: 'diffPrice',
					width: 150
				},  {
          title: '兑换券价格',
          dataIndex: 'price',
          width: 150
        },{
					title: '兑换券数量',
					dataIndex: 'importCount',
					key: 'importCount',
					width: 130
				}, {
					title: '已绑定数量',
					dataIndex: 'bindCount',
					key: 'bindCount',
					width: 130
				}, {
					title: '未兑换数量',
					key: 'redeemedCount',
					width: 130
				}, {
					title: '是否用于商品卖品发放',
					key: 'isGrant'
				}, {
					title: '操作人员',
					dataIndex: 'operationUserName',
					width: 180
				}, {
					title: '创建时间',
					key: 'createdTime',
					width: 200
				}, {
					title: '操作',
					fixed: 'right',
					key: 'action',
					width: 150
				}],
				pagination: {
					showSizeChanger: true,
					showQuickJumper: true,
					size: "middle",
					showTotal: (total) => {
						return "共 " + total + " 条";
					},
					total: 0,
					current: 1,
					pageSize: 10,
					onChange: (page) => {
						this.pagination.current = page;
						this.getData();
					},
					onShowSizeChange: (page, pageSize) => {
						this.pagination.current = 1;
						this.pagination.pageSize = pageSize;
						this.getData();
					}
				},
				showEditModal: false,
				isEdit: false,
				isSee: false,
				id: 0,
				pageType: 1,
        organizationId:"",
        isOneCardOpen: 0,  //是否开放一卡/券通, 0: 不开放, 1: 开放
			}
		},
		created() {
			if (this.$router.currentRoute.value.path === '/coupon/preferential/record') {
				this.pageType = 0;
			} else if (this.$router.currentRoute.value.path === '/coupon/preferential/recordInfo') {
				this.pageType = 1;
				this.columns.splice(13, 1);
			}
			this.getOrganizationList();
      this.getCinemaSetting();
			//this.onSearch();
		},
		methods: {
			onBack(isRef) {
				this.showEditModal = false;
				this.showModal = false;
				if(isRef) {
					this.getData();
				}
			},
			onSearch() {
				this.pagination.current = 1;
				//this.pagination.pageSize = 10;
				this.searchData = JSON.parse(JSON.stringify(this.formState));
				this.searchData.pageType = this.pageType ? this.pageType : undefined;
				// this.searchData.organizationId = this.searchData.organizationId ? this.searchData.organizationId : undefined;
        //去掉organizationId
        delete this.searchData.organizationId

        this.searchData.cinemaId = this.searchData.cinemaId ? this.searchData.cinemaId : undefined;
				this.searchData.isHoliday = this.searchData.isHoliday !== '' ? this.searchData.isHoliday : undefined;
				this.searchData.isGrant = this.searchData.isGrant !== '' ? this.searchData.isGrant : undefined;

        this.searchData.isOneVoucher = this.searchData.isOneVoucher !== '' ? this.searchData.isOneVoucher : undefined;
        this.searchData.useCinemaId = this.searchData.useCinemaId !== '' ? this.searchData.useCinemaId : undefined;
				if (this.time && this.time.length) {
					this.searchData.validStartTime = this.time[0].startOf('day').unix();
					this.searchData.validEndTime = this.time[1].endOf('day').unix();
				}
				if (this.time1 && this.time1.length) {
					this.searchData.failureStartTime = this.time1[0].startOf('day').unix();
					this.searchData.failureEndTime = this.time1[1].endOf('day').unix();
				}
				this.getData();
			},
			reset() {
				this.$refs.form.resetFields();
				this.time = [];
				this.time1 = [];
				if (this.organizationList.length) {
					this.formState.organizationId = this.organizationList[0].id;
					this.getAllCinemaList(this.formState.organizationId, true);
				}
				this.onSearch();
			},
			async getData() {
				this.loading = true;
				try {
					let ret = await getImportRecord({
						page: this.pagination.current,
						pageSize: this.pagination.pageSize,
						couponType: 1,
						...this.searchData
					})
					this.loading = false;
					if (ret.code === 200) {
						this.list = ret.data.list;
						this.pagination.total = ret.data.totalCount;
					}
				} catch(e) {
					this.loading = false;
				}
			},
			async getOrganizationList() {
				this.loading = true;
				try {
					let ret = await getOrganizationList({
						page: 1,
						pageSize: 999999
					});
					if (ret.code === 200) {
						this.organizationList = ret.data.list;
						if (this.organizationList.length) {
							this.formState.organizationId = this.organizationList[0].id;
							this.getAllCinemaList(this.formState.organizationId, true);
						}
						this.onSearch();
					} else {
						this.loading = false;
					}
				} catch(e) {
					this.loading = false;
				}
			},
			async getAllCinemaList(organizationId, isSearch) {
				if (isSearch) {
					this.cinemaAllList = [];
					this.formState.cinemaId = 0;
				} else {
					this.cinemaList = [];
					this.importModelRef.cinemaId = undefined;
				}
				let ret = await getCinemaList({
					page: 1,
					pageSize: 999999,
					organizationId: organizationId ? organizationId : undefined
				})
				if (ret.code === 200) {
					if (isSearch) {
						this.cinemaAllList = ret.data.list;
					} else {
						this.cinemaList = ret.data.list;
					}
				}
			},
			onImportRecord(record) {
				this.fileList = [];
				this.importId = record.id;
				this.importVisible = true;
				this.$nextTick(() => {
					this.$refs.importFormRef.resetFields();
				})
			},
			onImportModal() {
				this.importId = 0;
				this.fileList = [];
				this.importVisible = true;
				this.$nextTick(() => {
					this.$refs.importFormRef.resetFields();
				})
			},
			onAdd() {
				this.id = 0;
				this.isEdit = false;
				this.isSee = false;
				this.showEditModal = true;
			},
			onEdit(item) {
				this.id = item.id;
				this.isEdit = true;
				this.isSee = false;
				this.showEditModal = true;
			},
			onSee(item) {
				this.id = item.id;
				this.isEdit = false;
				this.isSee = true;
				this.showEditModal = true;
			},
			onSubmit() {
				this.$refs.addForm.validateFields().then(() => {

				})
			},
			onDelete(item) {
				this.$confirm({
					title: '提示',
					content: '确定删除吗？删除后该批次下的所有兑换券也会删除',
					onOk: async ()=> {
						this.loading = true;
						try {
							let ret = await delAndSync({
								id: item.id
							});
							this.loading = false;
							if (ret.code === 200) {
								this.$message.success('操作成功');
								this.getData();
							}
						} catch(e) {
							this.loading = false;
						}
					}
				})
			},
			onImportCard() {
				if (this.fileList.length === 0) {
					return this.$message.warn('请上传文件');
				}
				const isLt1M = this.fileList[0].size / 1024 / 1024 < 1;
				if (!isLt1M) {
					this.$message.error('上传文件太大了, 最大只允许1M');
				}
				this.$refs.importFormRef.validateFields().then(async () => {
					let postData = {};
					if (!this.importId) {
						postData = this.$deepClone(this.importModelRef);
						postData.receiveStartTime = this.moment(postData.time[0]).startOf('day').valueOf() / 1000;
						postData.receiveEndTime = this.moment(postData.time[1]).endOf('day').valueOf() / 1000;
            if (!postData.isOneVoucher) {
              postData.cinemaIds = this.importModelRef.cinemaIds.join(',');
              const cinemaName = [];
              this.importModelRef.cinemaIds.forEach(item=>{
                const cinema = this.cinemaAllList.find(subItem=>{return item == subItem.id});
                if (cinema) cinemaName.push(cinema.name);
              })
              postData.cinemaNames = cinemaName.join(',');
              if (!postData.cinemaIds.length) {
                return this.$message.error('请选择可用影院');
              }
            } else {
              postData.cinemaIds = '';
            }
					} else {
						postData.id = this.importId;
					}
					this.loading = true;
					try {
						let ret;
						if (!this.importId) {
							ret = await importExcel(postData, this.fileList[0]);
						} else {
							ret = await importRecordExcel(postData, this.fileList[0]);
						}
						this.loading = false;
						if (ret.code === 200) {
							this.$message.success('导入任务创建成功，请前往【卡券-任务中心-卡券任务列表】查看进度详情');
							this.$refs.importFormRef.resetFields();
							this.fileList = [];
							this.resetImportModelRef();
							this.getData();
						}
					} catch(e) {
						this.loading = false;
					}
				})
			},
      resetImportModelRef() {
        this.importVisible = false;
        // 重置数据
        this.importModelRef = {
          isHoliday: 1,
          isDisabled: 0,
          isGrant: 0,
          isOneVoucher: 0,
          cinemaIds: []
        };
		  },
			onDetail(item) {
				this.id = item.id;
        this.organizationId = item.organizationId
				this.showModal = !this.showModal

			},
			beforeUpload(file) {
				const isLt1M = file.size / 1024 / 1024 < 1;
				if (!isLt1M) {
					this.$message.error('上传文件太大了, 最大只允许1M');
				}
				return false;
			},
      async getCinemaSetting() {
        const ret = await getCinemaSetting({});
        if (ret.code === 200) {
          this.isOneCardOpen = ret.data.isBatchOpen;
          if (!this.isOneCardOpen) this.modelRef.isOneVoucher = 0;
        }
      },
		}
	}
</script>

<style scoped>
	.ui-form__item {
		margin-right: 30px;
	}
</style>
